export const isFunction = (value: unknown): value is (...args: unknown[]) => unknown => {
  return typeof value === 'function'
}

export const isNumber = (value: unknown): value is number => {
  return typeof value === 'number' && !isNaN(value)
}
